// extracted by mini-css-extract-plugin
export var author = "menuItem-module--author--29fa3";
export var badge = "menuItem-module--badge--93ae8";
export var category = "menuItem-module--category--8edd0";
export var headline = "menuItem-module--headline--ce86d";
export var headlinePost = "menuItem-module--headline-post--0ac77";
export var menuTitle = "menuItem-module--menu-title--6a0c5";
export var paragraph = "menuItem-module--paragraph--46aa0";
export var titleName = "menuItem-module--title-name--b892d";